/* jshint esversion: 6 */
exports.install = function (Vue, options) {
  console.log('options', options);
  // 用户信息
  Vue.prototype.userInfo = options.store.state.getUserInfo;

  // qs
  // Vue.prototype.qs = this.$Qs

  /**
   * 判断是否是数字
   * @param {String | Number} val 需要判断的值
   */
  Vue.prototype.isRealNum = (val) => {
    // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除 val.replace(/\s/g, '')
    if (val === '' || val == null) return false;
    // isNaN()函数来判断一个值是否是数字
    return typeof val === 'number' && !isNaN(val);
  };

  /**
   * 获取地址栏url中的参数值
   * @param {String} name 参数名
   */
  Vue.prototype.getUrlParam = function (name) {
    // 构造一个含有目标参数的正则表达式对象
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    // 匹配目标参数
    var r = window.location.search.substr(1).match(reg);
    // 返回参数值
    if (r != null) return unescape(r[2]); return null;
  };

  /**
   * 获取地址栏url中的参数值(解决中文乱码)
   * @param {String} name 参数名
   */
  Vue.prototype.getZhUrlParam = function (name) {
    // 构造一个含有目标参数的正则表达式对象
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    // 匹配目标参数
    var r = window.location.search.substr(1).match(reg);
    // 返回参数值
    if (r != null) return decodeURIComponent(r[2]); return null;
  };

  /**
   * 设置Cookie
   * @param {String} cname Cookie名
   * @param {*} cvalue Cookie值
   * @param {*} exhours Cookie存在时间（单位：h）
   */
  Vue.prototype.setCookie = function (cname, cvalue, exhours) {
    var d = new Date();
    d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
  };

  /**
   * 获取Cookie
   * @param {String} cname Cookie名
   */
  Vue.prototype.getCookie = function (cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  };

  /**
   * 删除Cookie
   * @param {String} cname Cookie名
   */
  Vue.prototype.delCookie = function (cname) {
    this.setCookie(cname, ' ', -1);
  };

  /**
   * 无刷新，改变地址栏
   * @param {String} subValue 地址栏需要截掉的参数，例：token=
   */
  Vue.prototype.replaceUrl = function (subValue) {
    var newUrl = window.location.href;
    let tokenIndex = newUrl.indexOf(subValue);
    if (tokenIndex !== -1) {
      // 获取该参数后面的&符合下标
      let _index = newUrl.indexOf('&', tokenIndex + 1);
      // 获取前一个字符
      const _tokenPreChar = newUrl.charAt(tokenIndex - 1);
      if (_tokenPreChar === '?' && _index !== -1) _index += 1;
      else tokenIndex -= 1;
      if (_index === -1) _index = newUrl.length;
      const _subStr = newUrl.substring(tokenIndex, _index);
      newUrl = newUrl.replace(_subStr, '');
      history.replaceState(null, null, newUrl);
    }
  };

  /**
   * 判断字符串是否为空
   * @param {String} obj 字符串
   */
  Vue.prototype.isEmpty = (obj) => {
    if (typeof obj === 'undefined' || obj == null || obj === '') return true;
    var regu = '^[ ]+$';
    var re = new RegExp(regu);
    return re.test(obj);
  };

  /**
   * 判断数组是否为空
   * @param {Array} obj 数组
   */
  Vue.prototype.isEmptyArray = (obj) => {
    if (typeof obj === 'undefined' || obj == null || obj.length === 0) return true;
    return false;
  };

  /**
   * 判断json是否为空
   * @param {Object} obj 对象
   */
  Vue.prototype.isEmptyObject = (obj) => {
    for (var key in obj) {
      return false;
    }
    return true;
  };

  /**
   * 禁止滚动条滚动
   */
  Vue.prototype.unScroll = function () {
    var top = $(document).scrollTop();
    $(document).on('scroll.unable', function (e) {
      $(document).scrollTop(top);
    });
  };

  /**
   * 移除禁止滚动条滚动
   */
  Vue.prototype.removeUnScroll = function () {
    $(document).unbind('scroll.unable');
  };

  /**
   * 判断图片url是否有效
   * @param {String} imgurl 图片地址
   */
  Vue.prototype.isImageUsable = function (imgurl) {
    return new Promise(function (resolve, reject) {
      // 判断图片是否存在
      const ImgObj = new Image();
      ImgObj.src = imgurl;
      ImgObj.onload = function (res) {
        resolve(res);
      };
      ImgObj.onerror = function (err) {
        reject(err);
      };
    }).catch((e) => {}); // 加上这句不会报错（Uncaught (in promise)）
  };

  /**
   * 判断字符串是否以某个字符开头
   * @param {*} str 原字符串
   * @param {*} startStr 判断的开头字符
   */
  Vue.prototype.isStartWith = (str, startStr) => {
    // const length = startStr.length
    // if (str.slice(0, length) === startStr) return true
    const reg = new RegExp('^' + startStr + '.*$');
    if (reg.test(str)) return true;
    return false;
  };

  /**
   * 判断字符串是否以某个字符结尾
   * @param {*} str 原字符串
   * @param {*} endStr 判断的结尾字符
   */
  Vue.prototype.isEndWith = (str, endStr) => {
    const reg = new RegExp(endStr + '$');
    if (reg.test(str)) return true;
    return false;
  };

  /**
   * 数组删除指定的值
   * @param {Array} arr 原数组
   * @param {Object | String | Number} value 指定删除的值
   */
  Vue.prototype.deleteArray = (arr, value) => {
    var index = arr.indexOf(value);
    arr.splice(index, 1);
    return arr;
  };

  /**
   * 判断数组中某个值是否存在
   * @param {Array} arr 原数组
   * @param {String | Number} value 需要判断的值
   */
  Vue.prototype.ifExists = (arr, value) => {
    let flag = false;
    arr.some((item) => { if (item === value) return (flag = true); });
    return flag;
  };

  /**
   * 判断数组中某个对象属性值是否存在
   * @param {Array} arr 原数组
   * @param {String} prop 需要判断对象的属性
   * @param {String | Number} value 需要判断的值
   */
  Vue.prototype.ifObjectExists = (arr, prop, value) => {
    let flag = false;
    arr.some((item) => { if (item[prop] === value) return (flag = true); });
    return flag;
  };

  /**
   *  根据指定个数切割数组
   * @param {Array} arr 需要切割的原数组
   * @param {Number} sliceLen 切割每个数组数量
   */
  Vue.prototype.sliceArray = (arr, sliceLen) => {
    let newArr = [];

    // 数组长度
    let arrLength = arr.length;
    let index = 0;
    for (let i = 0; i < arrLength; i++) {
      // 可以被 sliceLen 整除
      if (i % sliceLen === 0 && i !== 0) {
        newArr.push(arr.slice(index, i));
        index = i;
      }
      if ((i + 1) === arrLength) {
        newArr.push(arr.slice(index, (i + 1)));
      }
    }
    
    return newArr;
  };

  /**
   * 获取数组中对象值
   * @param {Araay} arr 原数组
   * @param {String} pname 姓名 Key
   * @param {String} puri uri Key
   * @param {String} separator 分隔符
   * @returns 
   */
  Vue.prototype.personListHandle = (arr, pname, puri, separator) => {
    if (typeof arr === 'undefined' || arr == null || arr.length === 0) return '';
    var newArr = [];
    var aTag = '';
    arr.forEach((item, idnex) => {
      aTag = "<a href='https://ldy.library.sh.cn/person/personDetailAll?uri="+ item[puri] +"' target='_blank'>";
      aTag += item[pname];
      aTag += "</a>";
      newArr.push(aTag);
    });
    return newArr.join(separator);
  };

  /**
   * 拆分字符串并返回a标签
   * @param {*} str 原字符串
   * @param {*} separator 分隔符
   * @returns 
   */
  Vue.prototype.thenNameHandle = (str, separator) => {
    if (typeof str === 'undefined' || str == null || str === '') return '';
    var newArr = [];
    var aTag = '';
    var strArr = str.split(";");
    strArr.forEach((item, idnex) => {
      var nameArr = item.split('~');
      aTag = "<a href='https://ldy.library.sh.cn/movie/movieDetail?uri="+ nameArr[0] +"' target='_blank'>";
      aTag += "《"+nameArr[1]+"》";
      aTag += "</a>";
      newArr.push(aTag);
    });
    return newArr.join(separator);
  };

  /**
   * 老照片-点击量埋点-参数
   * @param {String} uri 
   * @param {String} title 
   * @param {String} image 
   * @returns 
   */
  Vue.prototype.increaseParamsHandling = (uri, title, image) => {
    return {
      uri: uri,
      title: title,
      image: image
    };
  };

  /**
   * 通用检索参数
   * @param {String | Number} searchType 检索类型 1：简单检索，2：高级检索，3：专业检索
   * @param {String} freetext 简单检索文本内容
   * @param {[Object]} cdtn 高级检索内容
   * @param {Object} facet 分面检索内容
   * @param {String} collection 年谱:类型,老照片:专题
   * @param {String} expression 专业检索参数
   * @param {Object} sorts 排序
   * @param {String} secondCdtn 二次检索
   * @param {Object} pager 分页
   * @param {Boolean} hasFacet 
   * @returns 
   */
  Vue.prototype.commonParamsHandling = (
    searchType='1', freetext='', cdtn=[], facet={}, 
    collection='', expression='', sorts={}, 
    secondCdtn='', pager={ "pageth": 1, "pageSize": 10 }, hasFacet=true
  ) => {
    return {
      "searchType": searchType,
      "freetext": freetext,
      "collection": collection,
      "expression": expression,
      "cdtn": cdtn,
      "facet": facet,
      "secondCdtn": secondCdtn,
      "pager": pager,
      "sorts": sorts,
      "hasFacet": hasFacet
    };
  };

  /**
   * 公用检索参数
   * @returns 
   */
  Vue.prototype.commonParams = () => {
    return {
      "searchType": 1,
      "freetext": '',
      "collection": '',
      "expression": '',
      "cdtn": [],
      "facet": {},
      "secondCdtn": '',
      "pager": { 
        "pageth": 1, 
        "pageSize": 10 
      },
      "sorts": {},
      "hasFacet": true
    };
  };

  /**
   * 分页
   * @param {Number} pageth 页码
   * @param {Number} pageSize 每页数量
   * @returns 
   */
  Vue.prototype.pagerParamHandling = (pageth=1, pageSize=10) => {
    return {
      "pageth": pageth, 
      "pageSize": pageSize
    };
  };

  /**
   * 高级检索参数
   * @param {String} field 
   * @param {String} value 
   * @param {String} type 
   * @param {String} logic 
   * @returns 
   */
  Vue.prototype.cdtnParamHandling = (field='TI', value='', type='0', logic='and') => {
    return {
      "logic": logic,
      "field": field,
      "value": value,
      "type": type
    };
  };

  /**
   * 分面检索参数
   * @param {String} CO 人物
   * @param {String} ORG 出版社
   * @param {String} IS 时间
   * @param {String} PL 地点url
   * @returns 
   */
  Vue.prototype.facetParamHandling = (CO, ORG, IS, PL) => {
    let facet = {};
    if(CO  != null) facet.CO  = CO;
    if(ORG != null) facet.ORG = ORG;
    if(IS  != null) facet.IS  = IS;
    if(PL  != null) facet.PL  = PL;
    return facet;
  };

  /**
   * 排序
   * @param {String} score 
   * @param {String} IS 
   * @param {String} CO 
   * @param {String} TI 
   * @returns 
   */
  Vue.prototype.sortsParamHandling = (score, IS, CO, TI) => {
    let sorts = {};
    if(score != null) sorts.score = score;
    if(IS != null) sorts.IS = IS;
    if(CO != null) sorts.CO = CO;
    if(TI != null) sorts.TI = TI;
    return sorts;
  };

  /**
   * 随机获取数组中n个元素
   * @param {Array} arr 原数组
   * @param {Number} n 获取元素个数
   * @returns 
   */
  Vue.prototype.randomArrayHandling = (arr, n=1) => {
    let newArr = [];
    if (arr && n > arr.length) return newArr;
    if (n === arr.length) return arr;

    let oldArr = arr;
    for (let i=0; i<n; i++) {
      let randomIndex = Math.floor(Math.random()*oldArr.length);
      newArr.push(oldArr[randomIndex]);
      oldArr.splice(randomIndex, 1);
    }
    return newArr;
  };

  /**
   * 字符串转JSON并获取图片路径
   * @param {String} res json字符串
   * @param {String} url 图片URL
   * @param {String} key 获取图片的key
   */
  Vue.prototype.imgPathHandle = (res, url, key) => {
    let json = JSON.parse(res);
    return url+json[key];
  };
};
